import BaseBlockMap from './BaseBlockMap';
import SavingsBlockMap from './SavingsBlockMap';


export default {
    ...BaseBlockMap,
    ...SavingsBlockMap,
};
